import styled from "styled-components"

import { colors, spacing, Text } from "@minuthq/meatball-ui-react"

import { useTranslate } from "src/i18n/useTranslate"
import LightBulbIcon from "src/ui/icons/lightbulb-on.svg"
import { ExternalLink } from "src/ui/Link/ExternalLink"
import { MCard } from "src/ui/MCard/MCard"

export function PortfolioAnalyticsTipsCard() {
  const { t, langKeys } = useTranslate()

  return (
    <MCard
      boxShadow={false}
      border={false}
      backgroundColor={colors.primaryLight}
      padding={spacing.L}
    >
      <Box>
        <SubtitleContainer>
          <LightBulbIcon width={24} height={24} />
          <Text variant="subtitle">
            {t(langKeys.portfolio_analytics_tips_title)}
          </Text>
        </SubtitleContainer>
        <div>
          <Text variant="bodyS" color="secondary">
            <li>{t(langKeys.portfolio_analytics_tips_check_battery_levels)}</li>
          </Text>
          <Text variant="bodyS" color="secondary">
            <li>
              {t(
                langKeys.portfolio_analytics_tips_keep_devices_away_from_signal_blockers
              )}
            </li>
          </Text>
          <Text variant="bodyS" color="secondary">
            <li>{t(langKeys.portfolio_analytics_tips_sync_pms)}</li>
          </Text>
        </div>
        {/* TODO: MON-1709 - Add link to blog post */}
        <ExternalLink href="#" showExternalIcon={false} color="primary">
          {t(langKeys.read_more)}
        </ExternalLink>
      </Box>
    </MCard>
  )
}

const Box = styled.div`
  display: grid;
  gap: ${spacing.M};
`

const SubtitleContainer = styled.div`
  display: flex;
  gap: ${spacing.XS};
`
